export const domain = 'ModalsModel'

export const onOpenModal = `${domain}/onOpenModal`
export const onCloseModal = `${domain}/onCloseModal`

export const onSetDidUserCloseModalUltimately = `${domain}/onSetDidUserCloseModalUltimately`
export const onGetDidUserCloseModalUltimately = `${domain}/onGetDidUserCloseModalUltimately`
export const onSaveDidUserCloseModalUltimately = `${domain}/onSaveDidUserCloseModalUltimately`

